import global from './global';
import has from '../core/has';
// !has('build-elide')
import * as Resize from 'resize-observer-polyfill';
import wrapper from './util/wrapper';
if (!has('build-elide')) {
    if (!global.ResizeObserver) {
        // default is undefined when UMD module is used
        global.ResizeObserver = Resize.default || Resize;
    }
}
export default wrapper('ResizeObserver', true);